<div
  class="ui-choice-group"
  role="radiogroup"
  [class.ui-choice-group-auto]="isAuto()"
  [class.ui-choice-group-stack]="isStack()"
  [class.ui-choice-group-two]="isTwoColumn()"
  [class.ui-choice-group-three]="isThreeColumn()"
  [attr.aria-label]="ariaLabel()"
  [attr.aria-describedby]="describedBy()"
  [attr.aria-invalid]="invalid() ? 'true' : null"
  [attr.aria-required]="required() ? 'true' : null"
>
  @for (option of options(); track option.id) {
    <button
      class="ui-choice-group-option"
      role="radio"
      type="button"
      [class.ui-choice-group-option-active]="option.id === selectedOptionId()"
      [disabled]="option.disabled === true"
      [attr.aria-checked]="option.id === selectedOptionId() ? 'true' : 'false'"
      (click)="handleOptionSelected(option)"
    >
      @if (option.iconLabel) {
        <span class="ui-choice-group-icon" aria-hidden="true">{{
          option.iconLabel
        }}</span>
      }
      <span class="ui-choice-group-copy">
        <span class="ui-choice-group-label">{{ option.label }}</span>
        @if (option.description) {
          <span class="ui-choice-group-description">{{
            option.description
          }}</span>
        }
      </span>
    </button>
  }
</div>
